import { getService } from "hooks/useStartup"

import { FetchClient } from "@/core/client/fetch_client"
import { ListModel } from "@/core/generated/api/models/list_model"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { ICompany } from "@/features/companies/types"
import { CompanyItemModel } from "../../models/companyItemModel"
import { parseCompanyItem } from "../../utils/parseCompanyItem"

/** Loads the space's companies from GET /nxt/companies. Exported on its own for the companies Recoil atom, which cannot call hooks. */
export const getCompanies = async (): Promise<ICompany[]> => {
  const client: FetchClient = getService(FetchClient)
  const response = await client.getAsync(`/nxt/companies`)
  const model: ListModel<CompanyItemModel> | null =
    ResponseSerializer.deserialize<ListModel<CompanyItemModel>>(response)
  return (model?.items ?? []).map(parseCompanyItem)
}

export const useGetCompanies = () => {
  return { getCompanies }
}
